import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import { MFA } from './components/MFA';
import { Error } from './components/Error';
import { FeatureFlagProvider } from './components/FeatureManagement';

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <FeatureFlagProvider>
      <Layout>
        <Route path='/clientapp/Error' component={Error} />
        <Route path='/clientapp/MFA' component={MFA} />
      </Layout>
      </FeatureFlagProvider>
    );
  }
}
